import {bus, axios, i18n, apiURL} from '@/main'

export default {
    state: {
        /*
        kriterien: {
            list: [],
            dict: {}
        },
        */
        pakete: [],
        GT: {
            paketID: 2,
            arrayRef: null,
            status: null,
            hasRGSAnmeldung: false
        },
        CMP: {
            paketID: 3,
            arrayRef: null,
            gtEmmiFreigabe: false,
        },
        MA: {
            paketID: 4,
            arrayRef: null,
        },
    },
    actions: {
        /*
        loadKriterien: async function ({ commit }) {
            try {
                var kriterien = await axios.get(apiURL + 'datenpakete.cfc?method=getKriterien')
                await commit('setKriterien', kriterien.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading criteria ... ' + JSON.stringify(e.message))
            }
        },
        */
        loadPakete: async function ({commit}) {
            try {
                var pakete = await axios.get(apiURL + 'datenpakete.cfc?method=getPakete')
                await commit('setPakete', pakete.data)
            } catch (e) {
                bus.$emit('error', 'Error loading data packets ... ' + JSON.stringify(e.message))
            }
        },
        loadGT: async function ({state, commit}) {
            try {
                var gt = await axios.get(apiURL + 'datenpakete.cfc?method=getDeklaration', {params: {paketID: state.GT.paketID}})

                gt.data.forEach(function (kriterium) {
                    commit('setGTValue', {id: kriterium.id, value: kriterium.value, key: kriterium.key})
                })
            } catch (e) {
                bus.$emit('error', 'Error loading criteria ... ' + JSON.stringify(e.message))
            }
            // anmeldeemail rgs
            try {
                var response = await axios.get(apiURL + 'datenpakete.cfc?method=hasAnmeldungRGS')
                state.GT.hasRGSAnmeldung = (await response.data >= 1) ? true:false
            } catch (e) {
                bus.$emit('error', 'Error loading rgs infos ... ' + JSON.stringify(e.message))
            }

        },
        loadCMP: async function ({state, commit}) {
            axios.get(apiURL + 'datenpakete.cfc?method=getDeklaration', {params: {paketID: state.CMP.paketID}}).then(function (paket) {
                paket.data.forEach(function (kriterium) {
                    state.pakete[state.CMP.arrayRef].kriterien.filter(krtX => krtX.id === kriterium.id)[0].value = (kriterium.value != null) ? kriterium.value.toString() : null
                })
                //gtEmmiFreigabe emmi muss zwingend den Grünen Teppich haben
                state.CMP.gtEmmiFreigabe = (state.pakete[state.CMP.arrayRef].kriterien.filter(k => k.key === 'GruenerTeppich')[0].value);
                //Beim Speichern soll dann die Freigabe vom Coop mitgeschrieben werden
                state.pakete[state.CMP.arrayRef].organisationen[0].freigabe = true
                commit('setCoopPaket', state.pakete[state.CMP.arrayRef])
            })
        },
        savePaket: async function ({state}, paketInfo) {//paketInfo{id, declaration, approval}
            const formData = new FormData()
            const paketID = paketInfo.id
            let kriterien = []
            if (paketInfo.declaration) {
                state.pakete.filter(p => p.id === paketID)[0].kriterien.forEach(function (krtX) {
                    kriterien.push({
                        id: krtX.id,
                        value: (typeof (krtX.value) == "undefined" || krtX.value === "NaN" || krtX.value === "Infinity" || krtX.value === "-Infinity" || krtX.value === null) ? null : krtX.value
                    })
                })
            }
            let freigaben = []
            if (paketInfo.approval) {
                freigaben = state.pakete.filter(p => p.id === paketID)[0].organisationen
            }
            formData.append('paketID', paketID)
            formData.append('agb', (paketInfo.approval))
            formData.append('kriterien', JSON.stringify({arr: kriterien}))
            formData.append('freigaben', JSON.stringify({arr: freigaben}))
            await axios.post(apiURL + 'datenpakete.cfc?method=setPaketDaten&paketID=' + paketID, formData, {timeout: 60000})
                .then(function () {
                    if (paketInfo.approval) {
                        bus.$emit('paketSaved', paketID, "")
                    }
                })
                .catch(function (error) {
                    if (paketInfo.approval) {
                        bus.$emit('paketSaved', paketID, error.response.headers.clientmessage)
                    }
                })
        },
        setFreigabeChanged({commit}, freigabe) {// freigabe: { orgid :orgid, indx: indx }
            commit('setGTFreigabe', freigabe)
        },
        setFreigabe: async function ({state}, paket) {
            state.pakete.filter(pakX => pakX.id === paket.id)[0] = paket
            var freigabeID = 0
            const formData = new FormData()
            formData.append('paketID', paket.id)
            if (paket.freigaben.length > 0 && paket.freigaben[0].bis === null)
                freigabeID = paket.freigaben[0].id
            formData.append('freigabeID', freigabeID)
            axios.post(apiURL + 'datenpakete.cfc?method=setFreigabe', formData).then(function (freigabe) {
                if (freigabe.data.bis === null) {
                    paket.freigaben.splice(0, 0, freigabe.data);
                    bus.$emit('success', i18n.t('FreigabeErstellt'))
                } else {
                    paket.freigaben[0].bis = freigabe.data.bis;
                    bus.$emit('success', i18n.t('FreigabeWiderrufen'))
                }
            })
            try {
                //nope
            } catch (e) {
                bus.$emit('error', 'Error saving data release ... ' + JSON.stringify(e.message))
            }
        },
        addGTExtraOrg({state}, extraOrg) { //bei einladungen wird die org dynamisch eingefügt ..
            state.einladungExtraOrg = extraOrg //org = {"orgid":100092,"von":"","freigabe":false,"organisation":"Emmi Schweiz AG","bis":null,"disabled":false} 

            if (state.pakete[state.GT.arrayRef].organisationen.filter(o => o.orgid === extraOrg.orgid).length === 0) {
                state.pakete[state.GT.arrayRef].organisationen.push(state.einladungExtraOrg)
            }
        },
        /*
        setUebergangGT: async function ({state}) {
            await axios.post(apiURL + 'datenpakete.cfc?method=setUebergangGT')
                .then(function () {
                    state.GT.status = -4
                })
                .catch(function () {
                    //state.GT.status = false
                })
        },
        */
        sendAnmeldungRGS: async function ({state}, infos) {
            const formData = new FormData();
            formData.append('mitgliedschaften', infos.mitgliedschaften)
            formData.append('bemerkungen', infos.bemerkungen)
            formData.append('tierarzt', infos.tierarzt.praxis + ', ' + infos.tierarzt.plz + ' ' + infos.tierarzt.ort)
            await axios.post(apiURL + 'datenpakete.cfc?method=sendAnmeldungRGS', formData)
                .then(function () {
                    //bus.$emit('success', i18n.t('Angemeldet'))
                    state.GT.hasRGSAnmeldung = true
                })
                .catch(function () {
                    state.GT.hasRGSAnmeldung = false
                })
        }
    },
    mutations: {
        /*
        setKriterien: function (state, kriterien) {
            state.kriterien.list = kriterien
            state.kriterien.dict = {}
            for (var i = 0; i < kriterien.length; i++) {
                state.kriterien.dict[kriterien[i].id] = kriterien[i]
            }
        },
        setKriterienDict: function (state, kriterien) {
            state.kriterien.dict = kriterien
        },
        */
        setPakete: function (state, pakete) {
            // Grüner Teppich, setzt state.GT.arrayRef, setzt defaultwerte
            pakete.forEach(function (element, index) {
                element.organisationen.forEach(orgX => orgX.disabled = orgX.freigabe)
                if (element.id === state.GT.paketID) {
                    state.GT.arrayRef = index
                    state.GT.status = element.kriterien.filter(krtX => krtX.key === 'GruenerTeppich')[0].value
                }
                if (element.id === state.CMP.paketID) {
                    state.CMP.arrayRef = index
                }
                if (element.id === state.MA.paketID) {
                    element.kriterien.forEach(function (kriteriumX) {
                        kriteriumX.showInitialState = true // erlaubt null ist noch nicht rot ..

                        kriteriumX.statefn = function (kritX) {
                            if (kriteriumX.disabled) {
                                return true
                            }
                            if ((kritX.value === null || kritX.value === "") && kritX.showInitialState) {
                                return null
                            }
                            return (kritX.value && kritX.value.toString().length) ? true : false
                        }

                        if (typeof kriteriumX.value == "undefined") {
                            kriteriumX.value = null
                        }
                        if (kriteriumX.typ === "select" && kriteriumX.value == 0) {
                            // Bitte wählen für Safaribrowser hat den wert null
                            kriteriumX.value = null
                        }
                        if (kriteriumX.typ === "radio" && kriteriumX.value == 0) {
                            // Bitte wählen für Safaribrowser hat den wert null
                            kriteriumX.value = null
                        }

                        //hier emitted die LebtagleistunsAuswahl ein Ereigniss das zum Deaktivieren (unten) führt
                        if (kriteriumX.key === "LebtagleistungManuell") {
                            kriteriumX.onChange = function () {
                                //nope
                                bus.$emit('LebtagleistungManuell', this.value)
                            }
                        }
                        // bei LebtagleistungManuell = Nein/-1  "((Kuhalter-(Erstkalbealter/12))*Milchmenge)/(Kuhalter*365*Milchkuehe)"
                        if (kriteriumX.key === "Kuhalter"
                            || kriteriumX.key === "Erstkalbealter"
                            /*||kriteriumX.key === "Milchmenge"
                            ||kriteriumX.key === "Milchkuehe"
                            */
                        ) {
                            kriteriumX.setDisabled = function (value) {
                                console.log('getEvent' + this.key)
                                this.disabled = (value === 1)
                            }
                            bus.$on('LebtagleistungManuell', (value) => {
                                kriteriumX.setDisabled(value);
                            })
                        }
                        // bei LebtagleistungManuell = Ja/1
                        if (kriteriumX.key === "LebtagleistungEingabe") {
                            kriteriumX.setDisabled = function (value) {
                                console.log('getEvent' + this.key + 'wert' + value)
                                this.disabled = (value === -1)
                            }
                            bus.$on('LebtagleistungManuell', (value) => {
                                kriteriumX.setDisabled(value);
                            })
                        }

                        if (kriteriumX.typ.match(/number/)) {
                            kriteriumX.typ = 'number'
                            if (typeof kriteriumX.min == "undefined") kriteriumX.min = -9999999999;
                            if (typeof kriteriumX.max == "undefined") kriteriumX.max = 9999999999;
                            kriteriumX.statefn = function (kritX) {
                                if (kriteriumX.disabled) {
                                    return true
                                }
                                if (kritX.value === null && kritX.showInitialState) {
                                    return null
                                }
                                let nmbr = 0
                                try {
                                    nmbr = Number.parseFloat(kritX.value)
                                } catch (e) {
                                    return false
                                }
                                return (nmbr >= kritX.min && nmbr <= kritX.max)
                            }

                        }
                    })
                    state.MA.arrayRef = index
                }

            })
            state.pakete = pakete
            if (typeof state.einladungExtraOrg === 'object' && state.pakete[state.GT.arrayRef].organisationen.filter(o => o.orgid === state.einladungExtraOrg.orgid).length === 0) {
                state.pakete[state.GT.arrayRef].organisationen.push(state.einladungExtraOrg)
            }
        },
        setGTValue: function (state, data) {
            // in CF18 id int und id string sind nicht === 
            state.pakete[state.GT.arrayRef].kriterien.filter(krtX => krtX.id === data.id)[0].value = data.value

            if (data.key === "BTS" || data.key === "RAUS") {
                let btsValue = state.pakete[state.GT.arrayRef].kriterien.filter(krtX => krtX.key === "BTS")[0].value
                let rausValue = state.pakete[state.GT.arrayRef].kriterien.filter(krtX => krtX.key === "RAUS")[0].value

                state.pakete[state.GT.arrayRef].kriterien.filter(krtX => krtX.key === "BTSundRAUS")[0].value = (btsValue > 0 && rausValue > 0) ? 1 : -1
            }

            if (data.key === "GruenerTeppich") {
                state.GT.status = data.value
            }
        },
        setGTFreigabe(state, freigabe) {
            state.pakete[state.GT.arrayRef].organisationen[freigabe.indx].freigabe = (state.pakete[state.GT.arrayRef].organisationen[freigabe.indx].freigabe !== 1)
        },
        setGTDisabled: function (state) {
            state.pakete[state.GT.arrayRef].organisationen.forEach(orgX => orgX.disabled = orgX.freigabe)
        },
        setCoopValue: function (state, data) {
            state.pakete[state.CMP.arrayRef].kriterien.filter(krtX => krtX.id === data.id)[0] = {
                ...state.pakete[state.CMP.arrayRef].kriterien.filter(krtX => krtX.id === data.id)[0],
                value: data.value.toString()
            }
        },
        clearCoop: function (state) {
            state.pakete.splice(state.CMP.arrayRef, 1)
        },
        setCoopPaket: function (state, paket) {
            state.pakete.splice(state.CMP.arrayRef, 1, paket)
        },
        setDPValue: function (state, data) { /* data = {paketID,kriteriumID,value} */
            state.pakete.filter(pak => pak.id === data.paketID)[0].kriterien.filter(krit => krit.id === data.kriteriumID)[0] = data.value.toString();
        }
    }
}